import { forwardRef } from "react";
import Fade, { FadeProps } from "@mui/material/Fade";

// Mirrors $motion-menu-*-duration / $motion-exit-* in _variables.custom.scss.
export const EXIT_MS = 100;
const ENTER_MS = 100;
const ENTER_SCALE = 0.995;
const EXIT_EASING = "ease-out";
const EXIT_SCALE = "0.97";

const reducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Opens and closes with a quick fade + subtle scale, from/toward the anchor
 * (Popover sets the paper's transform-origin). Built on Fade so MUI's
 * positioning callbacks still receive the node.
 */
export const MenuTransition = forwardRef<HTMLElement, FadeProps>(
  function MenuTransition({ onEnter, onEntering, onExit, ...props }, ref) {
    return (
      <Fade
        ref={ref}
        {...props}
        easing={{ exit: EXIT_EASING }}
        onEnter={(node, isAppearing) => {
          node.style.scale = "";
          onEnter?.(node, isAppearing);
        }}
        onEntering={(node, isAppearing) => {
          // After Popover's own onEntering has set transform-origin.
          onEntering?.(node, isAppearing);
          if (typeof node.animate === "function" && !reducedMotion()) {
            node.animate(
              [
                { opacity: 0, scale: ENTER_SCALE },
                { opacity: 1, scale: 1 },
              ],
              {
                duration: ENTER_MS,
                easing: EXIT_EASING,
              }
            );
          }
        }}
        onExit={(node) => {
          // Fade has just set `transition: opacity …`; add scale to it.
          if (!reducedMotion()) {
            node.style.transition += `, scale ${EXIT_MS}ms ${EXIT_EASING}`;
            node.style.scale = EXIT_SCALE;
          }
          onExit?.(node);
        }}
      />
    );
  }
);
